
import { useState, useEffect } from 'react';
import ApiClient from '../../API/api';

export const useCartPromotions = () => {
    const [promotions, setPromotions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPromotions = async () => {
            setLoading(true);
            try {
                const url = `cart-promotions/active`;
                const response = await ApiClient.performRequest(url, {});
                console.log("[DEBUG] CartPromotions response:", response);
                setPromotions(response);
            } catch (err) {
                console.error("[DEBUG] Error fetching promotions", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPromotions();
    }, []);

    return { promotions, loading, error };
};
